import config from './config'
import List from './list'

export default {
  ...config,
  config,
  list: List,
}
